!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports["@hotmart/cosmos"] = e() : t["@hotmart/cosmos"] = e();
}(self, function () {
  return function () {
    "use strict";

    var t = {
      7705: function _(t) {
        t.exports = function (t) {
          var e = [];
          return e.toString = function () {
            return this.map(function (e) {
              var n = "",
                  o = void 0 !== e[5];
              return e[4] && (n += "@supports (".concat(e[4], ") {")), e[2] && (n += "@media ".concat(e[2], " {")), o && (n += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), n += t(e), o && (n += "}"), e[2] && (n += "}"), e[4] && (n += "}"), n;
            }).join("");
          }, e.i = function (t, n, o, r, i) {
            "string" == typeof t && (t = [[null, t, void 0]]);
            var s = {};
            if (o) for (var a = 0; a < this.length; a++) {
              var c = this[a][0];
              null != c && (s[c] = !0);
            }

            for (var u = 0; u < t.length; u++) {
              var l = [].concat(t[u]);
              o && s[l[0]] || (void 0 !== i && (void 0 === l[5] || (l[1] = "@layer".concat(l[5].length > 0 ? " ".concat(l[5]) : "", " {").concat(l[1], "}")), l[5] = i), n && (l[2] ? (l[1] = "@media ".concat(l[2], " {").concat(l[1], "}"), l[2] = n) : l[2] = n), r && (l[4] ? (l[1] = "@supports (".concat(l[4], ") {").concat(l[1], "}"), l[4] = r) : l[4] = "".concat(r)), e.push(l));
            }
          }, e;
        };
      },
      6738: function _(t) {
        t.exports = function (t) {
          return t[1];
        };
      },
      5097: function _(t, e, n) {
        n.d(e, {
          Z: function Z() {
            return a;
          }
        });
        var o = n(6738),
            r = n.n(o),
            i = n(7705),
            s = n.n(i)()(r());
        s.push([t.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
        var a = s;
      }
    },
        e = {};

    function n(o) {
      var r = e[o];
      if (void 0 !== r) return r.exports;
      var i = e[o] = {
        id: o,
        exports: {}
      };
      return t[o](i, i.exports, n), i.exports;
    }

    n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, {
        a: e
      }), e;
    }, n.d = function (t, e) {
      for (var o in e) {
        n.o(e, o) && !n.o(t, o) && Object.defineProperty(t, o, {
          enumerable: !0,
          get: e[o]
        });
      }
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var o = {};
    return function () {
      n.r(o);

      var t = require("@babel/runtime/helpers/defineProperty");

      var e = n.n(t);

      var r = require("@babel/runtime/helpers/classCallCheck");

      var i = n.n(r);

      var s = require("@babel/runtime/helpers/createClass");

      var a = n.n(s);

      var c = require("@babel/runtime/helpers/assertThisInitialized");

      var u = n.n(c);

      var l = require("@babel/runtime/helpers/get");

      var d = n.n(l);

      var f = require("@babel/runtime/helpers/inherits");

      var h = n.n(f);

      var p = require("@babel/runtime/helpers/possibleConstructorReturn");

      var v = n.n(p);

      var m = require("@babel/runtime/helpers/getPrototypeOf");

      var b = n.n(m);

      var y = require("@babel/runtime/helpers/wrapNativeSuper");

      var g = n.n(y),
          _ = n(5097);

      var w = function (t) {
        h()(r, t);
        var e,
            n,
            o = (e = r, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              o = b()(e);

          if (n) {
            var r = b()(this).constructor;
            t = Reflect.construct(o, arguments, r);
          } else t = o.apply(this, arguments);

          return v()(this, t);
        });

        function r(t) {
          var e;
          i()(this, r);
          var n = (e = o.call(this)).getTemplate(),
              s = document.createElement("template");
          s.innerHTML = n;
          var a = s.content.querySelector("style");
          return a && (a.innerHTML = "".concat(a.innerHTML, " ").concat(_.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(s, t), e.attachShadow({
            mode: "open"
          }), e.shadowRoot.appendChild(document.importNode(s.content, !0)), e;
        }

        return a()(r, [{
          key: "connectedCallback",
          value: function value() {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function value() {
            return "";
          }
        }]), r;
      }(g()(HTMLElement)),
          T = "hot-toast",
          S = "toastsuccess",
          E = "toastwarning",
          O = "toastdanger",
          k = "toastcustom",
          j = "toastinfo";

      function x(t, e) {
        var n = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(t);
          e && (o = o.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, o);
        }

        return n;
      }

      function P(t) {
        for (var n = 1; n < arguments.length; n++) {
          var o = null != arguments[n] ? arguments[n] : {};
          n % 2 ? x(Object(o), !0).forEach(function (n) {
            e()(t, n, o[n]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : x(Object(o)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
          });
        }

        return t;
      }

      var C,
          L,
          I = function (t) {
        h()(r, t);
        var e,
            n,
            o = (e = r, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              o = b()(e);

          if (n) {
            var r = b()(this).constructor;
            t = Reflect.construct(o, arguments, r);
          } else t = o.apply(this, arguments);

          return v()(this, t);
        });

        function r() {
          var t;
          return i()(this, r), (t = o.call(this, T))._portal = null, t._toasts = [], t.info = t.info.bind(u()(t)), t.success = t.success.bind(u()(t)), t.danger = t.danger.bind(u()(t)), t.warning = t.warning.bind(u()(t)), t.custom = t.custom.bind(u()(t)), t._onToastInfo = function (e) {
            return t.info(e.detail);
          }, t._onToastSuccess = function (e) {
            return t.success(e.detail);
          }, t._onToastDanger = function (e) {
            return t.danger(e.detail);
          }, t._onToastWarning = function (e) {
            return t.warning(e.detail);
          }, t._onToastCustom = function (e) {
            return t.custom(e.detail);
          }, t;
        }

        return a()(r, [{
          key: "connectedCallback",
          value: function value() {
            d()(b()(r.prototype), "connectedCallback", this).call(this), window.addEventListener(j, this._onToastInfo), window.addEventListener(S, this._onToastSuccess), window.addEventListener(O, this._onToastDanger), window.addEventListener(E, this._onToastWarning), window.addEventListener(k, this._onToastCustom);
          }
        }, {
          key: "disconnectedCallback",
          value: function value() {
            window.removeEventListener(j, this._onToastInfo), window.removeEventListener(S, this._onToastSuccess), window.removeEventListener(O, this._onToastDanger), window.removeEventListener(E, this._onToastWarning), window.removeEventListener(k, this._onToastCustom);

            for (var t = this._toasts.length - 1; t >= 0; t--) {
              this._removeToast(this._toasts[t].id, !0);
            }
          }
        }, {
          key: "info",
          value: function value(t) {
            this._createToast("hot-alert--info", {
              detail: t
            });
          }
        }, {
          key: "success",
          value: function value(t) {
            this._createToast("hot-alert--success", {
              detail: t
            });
          }
        }, {
          key: "warning",
          value: function value(t) {
            this._createToast("hot-alert--warning", {
              detail: t
            });
          }
        }, {
          key: "danger",
          value: function value(t) {
            this._createToast("hot-alert--danger", {
              detail: t
            });
          }
        }, {
          key: "custom",
          value: function value(t) {
            this._createToast("hot-alert--custom", {
              detail: t
            });
          }
        }, {
          key: "_createToast",
          value: function value(t, e) {
            var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                o = e.detail || {},
                r = "hot-toast-".concat(Math.random().toString(36).substr(2, 9)),
                i = P({
              id: r,
              variation: t,
              dismissible: n,
              message: "",
              position: "right top",
              className: ""
            }, o);
            this._toasts.push(i), this._renderAlerts(), this._updatePositionAlerts();
          }
        }, {
          key: "_removeToast",
          value: function value(t) {
            var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                n = this._toasts.findIndex(function (e) {
              return e.id === t;
            }),
                o = this._toasts[n];

            if (o) {
              this._toasts.splice(n, 1);

              var r = document.getElementById(o.id);
              r && e && r.dismiss();
            }

            this._updatePositionAlerts();
          }
        }, {
          key: "_renderAlerts",
          value: function value() {
            var t = this,
                e = this.getAttribute("dismissible-time") || 6e3;

            this._toasts.forEach(function (n) {
              var o = document.getElementById(n.id);

              if (!o) {
                (o = document.createElement("hot-alert")).style.position = "fixed", o.setAttribute("id", n.id), o.setAttribute("class", "fade hot-alert--toast ".concat(n.variation, " ").concat(n.className)), n.dismissible && o.setAttribute("dismissible", ""), o.innerHTML = n.message, o.style.transition = "all 500ms cubic-bezier(.2, 1, .2, 1)", t._portal ? t._portal.append(o) : document.body.appendChild(o);
                var r = setTimeout(function () {
                  return t._removeToast(n.id, !0);
                }, e);
                o.addEventListener("dismiss", function e() {
                  clearTimeout(r), o.removeEventListener("dismiss", e), t._removeToast(n.id, !1);
                });
              }
            });
          }
        }, {
          key: "_updatePositionAlerts",
          value: function value() {
            var t = this;

            this._toasts.forEach(function (e, n) {
              var o = 0,
                  r = document.getElementById(e.id);

              if (r) {
                for (var i = 0; i < n; i++) {
                  var s = t._toasts[i],
                      a = document.getElementById(t._toasts[i].id);
                  e.position === s.position && (o += a.offsetHeight + 24);
                }

                e.position.split(" ").forEach(function (t) {
                  "left" !== t && "right" !== t || (r.style[t] = "0"), "top" !== t && "bottom" !== t || (r.style[t] = "".concat(o, "px"));
                }), t._toasts.find(function (t) {
                  return t.id === e.id;
                }) && r.classList.add("show");
              }
            });
          }
        }, {
          key: "getTemplate",
          value: function value() {
            return "<slot></slot>";
          }
        }]), r;
      }(w);

      C = T, L = I, customElements.get(C) || customElements.define(C, L);
    }(), o;
  }();
});